/**
 * 361 Sleep — Section 8
 * Interactive numbered slideshow (tabs + crossfade + swipe).
 */
(function () {
  'use strict';

  var BOOTED = false;
  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  function whenGsap(fn) {
    if (window.gsap) {
      fn(window.gsap);
      return;
    }
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (window.gsap) {
        clearInterval(timer);
        fn(window.gsap);
      } else if (tries > 80) {
        clearInterval(timer);
        fn(null);
      }
    }, 50);
  }

  function initSection(section, gsap) {
    var stage = section.querySelector('[data-after-stage]');
    var slides = Array.prototype.slice.call(section.querySelectorAll('[data-after-slide]'));
    var tabs = Array.prototype.slice.call(section.querySelectorAll('[data-after-tab]'));
    if (!stage || slides.length < 2) return;

    var start = parseInt(section.getAttribute('data-start-index') || '0', 10);
    if (isNaN(start) || start < 0 || start >= slides.length) start = 0;
    var index = start;
    var busy = false;
    var touchX = null;

    var autoplayMs = parseInt(section.getAttribute('data-autoplay-ms') || '0', 10);
    if (isNaN(autoplayMs)) autoplayMs = 0;
    var autoplayOn = autoplayMs > 0 && !REDUCE && slides.length > 1;
    var timer = null;
    var visible = true;

    function stopAutoplay() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function startAutoplay() {
      stopAutoplay();
      if (!autoplayOn || !visible) return;
      timer = setInterval(function () {
        goTo(index + 1, { auto: true });
      }, autoplayMs);
    }

    /* Restart the countdown after any manual move so it doesn't jump early */
    function bumpAutoplay() {
      if (!autoplayOn) return;
      startAutoplay();
    }

    function syncStageHeight() {
      var max = 0;
      slides.forEach(function (slide) {
        var wasHidden = slide.style.visibility;
        var wasPos = slide.style.position;
        var wasPointer = slide.style.pointerEvents;
        slide.style.visibility = 'hidden';
        slide.style.position = 'static';
        slide.style.pointerEvents = 'none';
        max = Math.max(max, slide.offsetHeight);
        slide.style.visibility = wasHidden;
        slide.style.position = wasPos;
        slide.style.pointerEvents = wasPointer;
      });
      if (max > 0) stage.style.minHeight = max + 'px';
    }

    function setTabState(i) {
      tabs.forEach(function (tab, ti) {
        var on = ti === i;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
      });
    }

    function setSlideState(i) {
      slides.forEach(function (slide, si) {
        var on = si === i;
        slide.classList.toggle('is-active', on);
        slide.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (on) {
          slide.removeAttribute('inert');
        } else {
          slide.setAttribute('inert', '');
        }
      });
    }

    function goTo(next, opts) {
      opts = opts || {};
      if (busy) return;
      if (next < 0) next = slides.length - 1;
      if (next >= slides.length) next = 0;
      if (next === index && !opts.force) return;

      var prev = index;
      var from = slides[prev];
      var to = slides[next];
      index = next;
      setTabState(index);

      if (REDUCE || !gsap) {
        setSlideState(index);
        return;
      }

      busy = true;
      setSlideState(index);

      /* Keep outgoing slide visible during fade, then hide */
      from.style.visibility = 'visible';
      from.style.pointerEvents = 'none';
      to.style.visibility = 'visible';

      gsap.killTweensOf([from, to, from.querySelector('.after361__card'), to.querySelector('.after361__card')]);

      var fromCard = from.querySelector('.after361__card');
      var toCard = to.querySelector('.after361__card');

      gsap.set(to, { opacity: 0 });
      gsap.set(toCard, { y: 14 });
      gsap.set(from, { opacity: 1 });

      var tl = gsap.timeline({
        defaults: { ease: 'power2.out' },
        onComplete: function () {
          gsap.set(from, { clearProps: 'opacity,visibility,pointerEvents' });
          gsap.set(to, { clearProps: 'opacity' });
          gsap.set([fromCard, toCard], { clearProps: 'transform' });
          from.style.visibility = '';
          from.style.pointerEvents = '';
          busy = false;
        }
      });

      tl.to(from, { opacity: 0, duration: 0.35 }, 0);
      if (fromCard) tl.to(fromCard, { y: -10, duration: 0.35 }, 0);
      tl.to(to, { opacity: 1, duration: 0.45 }, 0.08);
      if (toCard) tl.to(toCard, { y: 0, duration: 0.5 }, 0.08);
    }

    /* Initial state */
    setTabState(index);
    setSlideState(index);
    syncStageHeight();
    window.addEventListener('resize', syncStageHeight);

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var i = parseInt(tab.getAttribute('data-index'), 10);
        if (!isNaN(i)) {
          goTo(i);
          bumpAutoplay();
        }
      });

      tab.addEventListener('keydown', function (event) {
        var key = event.key;
        var next = index;
        if (key === 'ArrowRight' || key === 'ArrowLeft') {
          event.preventDefault();
          /* LTR tab row: right = next */
          next = key === 'ArrowRight' ? index + 1 : index - 1;
          goTo(next);
          bumpAutoplay();
          if (tabs[index]) tabs[index].focus();
        } else if (key === 'Home') {
          event.preventDefault();
          goTo(0);
          bumpAutoplay();
          if (tabs[0]) tabs[0].focus();
        } else if (key === 'End') {
          event.preventDefault();
          goTo(slides.length - 1);
          bumpAutoplay();
          if (tabs[slides.length - 1]) tabs[slides.length - 1].focus();
        }
      });
    });

    /* Swipe on the card stage */
    stage.addEventListener(
      'touchstart',
      function (event) {
        if (!event.changedTouches || !event.changedTouches.length) return;
        touchX = event.changedTouches[0].clientX;
      },
      { passive: true }
    );

    stage.addEventListener(
      'touchend',
      function (event) {
        if (touchX == null || !event.changedTouches || !event.changedTouches.length) return;
        var dx = event.changedTouches[0].clientX - touchX;
        touchX = null;
        if (Math.abs(dx) < 48) return;
        /* Swipe left → next, swipe right → previous (LTR step order) */
        goTo(dx < 0 ? index + 1 : index - 1);
        bumpAutoplay();
      },
      { passive: true }
    );

    /* Keep autoplaying through hover/focus; only pause off-screen or when tab is hidden */
    if (autoplayOn) {
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          stopAutoplay();
        } else if (visible) {
          startAutoplay();
        }
      });

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              visible = entry.isIntersecting;
              if (visible) {
                startAutoplay();
              } else {
                stopAutoplay();
              }
            });
          },
          { threshold: 0.25 }
        );
        io.observe(section);
      }

      startAutoplay();
    }

    section._after361GoTo = goTo;
  }

  function boot() {
    whenGsap(function (gsap) {
      document.querySelectorAll('[data-after361]').forEach(function (section) {
        initSection(section, gsap);
      });
      BOOTED = true;
    });
  }

  ready(boot);

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target;
    if (!root || !root.querySelector) return;
    if (!root.querySelector('[data-after361]') && !(root.matches && root.matches('[data-after361]'))) {
      return;
    }
    boot();
  });
})();
